import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerAdminService } from "../../../services/api/consumer-admin.service";
import { ConsumerAdminActions } from "../../actions/consumer-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerUserRemoveEffects {
	create = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerAdminActions.user.remove),
			switchMap((action) =>
				this.consumerAdminService.removeUser(action.id).pipe(
					map(() => ConsumerAdminActions.user.removeSuccess({ id: action.id })),
					catchError((error) =>
						of(ConsumerAdminActions.user.removeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerAdminService: ConsumerAdminService
	) {}
}
